// components/Music/MusicSideBar.js
import React from 'react';

function MusicSidebar({ activeTab, onTabChange, stats }) {
  const tabs = [
    { id: 'songs', label: 'Songs', icon: '🎵' },
    { id: 'artists', label: 'Artists', icon: '👤' },
    { id: 'albums', label: 'Albums', icon: '💿' },
    { id: 'playlists', label: 'Playlists', icon: '📋' },
    { id: 'genres', label: 'Genres', icon: '🏷️' }
  ];

  return (
    <div className="rounded-xl overflow-hidden" style={{ background: '#111', border: '1px solid #1f1f1f' }}>
      <div className="px-4 py-3" style={{ borderBottom: '1px solid #1a1a1a' }}>
        <p className="text-xs font-bold uppercase tracking-widest" style={{ color: '#6b7280' }}>Library</p>
      </div>
      <nav className="p-2">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all mb-0.5"
            style={
              activeTab === tab.id
                ? { background: 'rgba(220,38,38,0.12)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }
                : { color: '#9ca3af', border: '1px solid transparent' }
            }
          >
            <span className="text-base">{tab.icon}</span>
            <span className="font-medium text-sm">{tab.label}</span>
            {stats && stats[tab.id] && (
              <span
                className="ml-auto text-xs px-2 py-0.5 rounded-md font-mono"
                style={
                  activeTab === tab.id
                    ? { background: 'rgba(220,38,38,0.2)', color: '#f87171' }
                    : { background: '#1a1a1a', color: '#6b7280' }
                }
              >
                {stats[tab.id]}
              </span>
            )}
            {activeTab === tab.id && (
              <div className="w-1.5 h-1.5 rounded-full ml-auto" style={{ background: '#dc2626' }} />
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}

export default MusicSidebar;